import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { useGet } from "../../lib/hooks";
import { useAuth } from "../../lib/auth";
import { Button } from "../ui/button";

const sel = "h-9 w-full rounded-md border border-input bg-background px-2 text-sm disabled:opacity-60";

export function EntityPeopleCard({ acc, reload }) {
  const { user, reloadAccounts } = useAuth();
  const [users] = useGet("/users");
  const [f, setF] = useState({ owner_user_id: "", admin_user_id: "", owner_is_admin: false });
  useEffect(() => setF({ owner_user_id: acc.owner_user_id || "", admin_user_id: acc.admin_user_id || "", owner_is_admin: !!acc.owner_is_admin }), [acc]);
  const edit = user.role === "agency_owner";
  const people = [...(user.role === "agency_owner" ? [user] : []), ...(users || []).filter((u) => !u.disabled && u.role !== "agency_owner")];
  const save = async () => {
    try { await api.put("/account/people", f); toast.success("Entity owner and administrator saved"); reload(); reloadAccounts?.(); } catch (e) { toast.error(errMsg(e)); }
  };
  const pick = (k, disabled) => (
    <select className={sel} disabled={!edit || disabled} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`entity-${k}`}>
      <option value="">Not assigned</option>
      {people.map((u) => <option key={u.id} value={u.id}>{`${u.name} · ${u.email}`}</option>)}
    </select>
  );
  return (
    <div className="rounded-md border bg-card p-5 space-y-3" data-testid="entity-people-card">
      <div className="overline">Entity owner & administrator</div>
      <p className="text-xs text-muted-foreground">These people see Features Builder and Settings and decide what their staff can access. The BOS HQ owner always has access.</p>
      <label className="block text-xs text-muted-foreground space-y-1"><span>Entity owner</span>{pick("owner_user_id")}</label>
      <label className="flex items-center gap-2 text-sm"><input type="checkbox" className="accent-[#C2A462]" disabled={!edit} checked={f.owner_is_admin} onChange={(e) => setF({ ...f, owner_is_admin: e.target.checked })} data-testid="entity-owner-is-admin" />The owner is also the Entity Admin (one person)</label>
      {!f.owner_is_admin && <label className="block text-xs text-muted-foreground space-y-1"><span>Entity Admin</span>{pick("admin_user_id")}</label>}
      {edit && <div className="flex justify-end"><Button size="sm" onClick={save} data-testid="entity-people-save">Save</Button></div>}
    </div>
  );
}

export function SupportCodeCard({ acc, reload }) {
  const { user, account } = useAuth();
  const mgr = user.role === "agency_owner" || [account?.owner_user_id, account?.admin_user_id].includes(user.id)
    || (user.role === "subaccount_admin" && !account?.owner_user_id && !account?.admin_user_id);
  if (!mgr || !acc.client_id) return null;
  const regen = async () => {
    if (!window.confirm("Generate a new Support Relationship Code? The old code will stop working.")) return;
    try { await api.post("/account/support-code/regenerate"); toast.success("New code generated"); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="rounded-md border border-[#C2A462]/30 bg-card p-5 space-y-3" data-testid="support-code-card">
      <div className="overline">BOS HQ support identity</div>
      <div className="grid sm:grid-cols-2 gap-3 text-sm">
        <div><div className="text-xs text-muted-foreground">Client ID</div><div className="font-mono text-[#EBD6A0]" data-testid="entity-client-id">{acc.client_id}</div></div>
        <div><div className="text-xs text-muted-foreground">Support Relationship Code</div><div className="font-mono text-[#EBD6A0] tracking-widest" data-testid="entity-support-code">{acc.support_code}</div></div>
      </div>
      <p className="text-xs text-muted-foreground">BOS HQ support will ask for these to confirm who you are. Never share them by email or with anyone outside your organisation.</p>
      <Button size="sm" variant="secondary" onClick={regen} data-testid="regen-support-code-btn">Generate new code</Button>
    </div>
  );
}
